<template>
	<client-page>
        <v-container>
            <div class="tit-wrap text-center">
                <h2 class="tit tit--lg">FAQ</h2>
            </div>

           <faq-list></faq-list>
        </v-container>
	</client-page>
</template>

<script>

import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import FaqList from "@/components/client/ko/center/faqs/faq-list.vue";

export default{
	components: {
        ClientPage,
		FaqList,
    },
}
</script>
